export const POSSIBLE_COUNTRIES_LOAD = 'POSSIBLE_COUNTRIES_LOAD';



// WEBPACK FOOTER //
// ./src/app/store/actions/countries.action.ts